<template>
  <div class="download-module">
    <div class="download-icon">
      <slot name="download-icon"></slot>
    </div>
    <a :href="href" class="download-btn" target="_blank">
      <slot name="download-btn"></slot>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    href: String
  }
}
</script>

<style lang="scss" scoped>
.download{
  &-icon {
    @media screen and (max-width: 768px) {
      margin-left: 15px;
    }
  }
  &-icon, &-btn{
    display: inline-block;
    vertical-align: middle;
  }

  &-btn{
    border-radius: .2rem;
    @include nkn-font-set(.9rem, #fff);
    text-align: center; padding-left: 10px; padding-right: 10px;
    background: #1791f2;
    @media screen and (max-width: 768px){
      /*float: right;*/
      /*margin-top: 10px;*/
      /*margin-right: 5px;*/
    }
    &:hover{
      background: #51B2FF;
    }

    &:active{
      background: #0180E4;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/miner/plugins/DownloadModule.vue